import { api } from "..";

export function createDeviceRequest(data) {
  return api.post("/v1/device/create", data);
}

export function updateDeviceRequest({ id, data }) {
  return api.put(`/v1/device/${id}`, data);
}

export function getDevicesRequest({ params }) {
  return api.get(`/v1/device`, {
    params,
  });
}

export function getDeviceByIdRequest({ id, params }) {
  return api.get(`/v1/device/${id}`, { params });
}
